import styled, { StyledFunction } from "styled-components";
import { Rotate360 } from "../styles";

interface ILoadingOverlay {
    loading?: boolean,
    top?: number,
    left?: number
}

export const StyledLoadingOverlay = styled.div`
    position: fixed;
    display: ${(p: ILoadingOverlay) => p.loading ? "block" : "none"};
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgba(161, 161, 161, 0.6);
    z-index: 9999998;
    cursor: pointer;
`;

export const StyledLoadingIndicator = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: -100px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    height: 95px;
    // width: 180px;
    z-index: 9999999;
    //background-color: white;
    //background-color: rgba(161,161,161,0.7);
    padding-top: 5px;
`;

export const StyledLoadingImage = styled.div`
    border: 5px solid ${(p: any) => p.theme.activeInverseBackgroundColor ? p.theme.activeInverseBackgroundColor : "mediumgrey"};
    border-top: 5px solid ${(p: any) => p.theme.inverseBackgroundColor ? p.theme.inverseBackgroundColor : "#FF502D"};
    border-radius: 50%;
    background-color: ${(p: any) => p.theme.appBackgroundColor};
    width: 80px;
    height: 80px;
    animation: ${Rotate360} 1s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    margin-top: -40px;
    margin-left: -40px;
`;

export const StyledLoadingMessage = styled.div`
    color: ${(p: any) => p.theme.textColor ? p.theme.textColor : "black"};
    color: black;
    font-size: 18px;
    font-weight: 600;
    //position: absolute;
    //top: 48%;
    //bottom: 45%;
    //left: 50%;
    //animation: 0;
    //transform: translate(-50%,-50%);
    //-ms-transform: translate(-50%,-50%);
    //background-color: #7F7F7F;
    //background-color: black;
    // background-color: #FFFFFF;
    padding: 5px;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;
